import { render, staticRenderFns } from "./orgContainer.vue?vue&type=template&id=1e20f75b&scoped=true&"
import script from "./orgContainer.vue?vue&type=script&lang=js&"
export * from "./orgContainer.vue?vue&type=script&lang=js&"
import style0 from "./orgContainer.vue?vue&type=style&index=0&id=1e20f75b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20f75b",
  null
  
)

export default component.exports